import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LanguageContext } from './LanguageContext';
import './Header.css';
import { useSwipeable } from 'react-swipeable';

function Header() {
    const { language, setLanguage } = useContext(LanguageContext);
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleLanguageChange = (event) => {
        setLanguage(event.target.value);
    };

    const handleContactClick = () => {
        navigate('/contact');
        setIsMenuOpen(false);
    };

    const handleDropdownItemClick = (path) => {
        navigate(path);
        setIsMenuOpen(false);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleHomeClick = (e) => {
        e.preventDefault(); // Prevent default link behavior
        navigate('/'); // Navigate to the home route
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const handleAboutClick = (e) => {
        e.preventDefault(); // Prevent default link behavior
        navigate('/about'); // Navigate to the about route
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <header className="App-header bg-light" sticky="bottom">
            <nav className="navbar navbar-expand-lg navbar-light bg-light" ref={dropdownRef}>
                <Link className="navbar-brand" to="/">
                    <img src="/images/tacologoj.jpg" alt="Logo" className="logo" />
                </Link>
                <button className="navbar-toggler" type="button" onClick={toggleMenu} aria-controls="navbarNav" aria-expanded={isMenuOpen} aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse justify-content-between ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" to="/" onClick={handleHomeClick}>{language === 'en' ? 'HOME' : 'ANA SAYFA'}</Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to="/products" onClick={() => handleDropdownItemClick('/products')}>{language === 'en' ? 'PRODUCTS' : 'ÜRÜNLER'}</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/about" onClick={handleAboutClick}>{language === 'en' ? 'ABOUT US' : 'HAKKIMIZDA'}</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/partners" onClick={() => handleDropdownItemClick('/partners')}>{language === 'en' ? 'PARTNERS' : 'ORTAKLAR'}</Link>
                        </li>
                    </ul>
                    <div className="nav-buttons">
                        <button className="btn btn-outline-primary mx-2" variant="outline-dark" onClick={handleContactClick}>
                            {language === 'en' ? 'CONTACT' : 'İLETİŞİM'}
                        </button>
                        <select value={language} onChange={handleLanguageChange} className="btn btn-outline-primary mx-2">
                            <option value="en">English</option>
                            <option value="tr">Türkçe</option>
                        </select>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;
